import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import { useEffect, useRef, useState } from "react";
import { Overlay, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  getAcumaticaHerbById,
  getClassicFormula,
  getHerbByFormulaId,
  getHerbById,
  getModificationByFormulaId,
} from "../../actions/formulaAction";
import { ERROR } from "../../constants/types/alertType";
const SearchByFormulaList = ({
  isRawType,
  closePopup,
  includeDosage,
  setIncludeDosage,
  fromCustomFormula,
}) => {
  const formulaList = useSelector(
    (state) => state.formula.present.classicFormulaList
  );
  const formulas = useSelector((state) => state.formula.present.formulaSection);
  const modificationList = useSelector(
    (state) => state.formula.present.modificationByFormulaList
  );
  const target = useRef(null);
  const [filteredList, setFilteredList] = useState([]);
  const [selectedFormula, setSelectedFormula] = useState(null);
  const [selectedMod, setSelectedMod] = useState(null);
  const [dosage, setDosage] = useState();
  const selectRef = useRef(null);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getClassicFormula());
    return () => {
      dispatch(getModificationByFormulaId(0));
    };
  }, [dispatch]);

  useEffect(() => {
    setFilteredList(modificationList);
    if (selectRef.current) {
      selectRef.current.focus();
    }
  }, [modificationList]);

  const handleItemChange = (id) => {
    setSelectedFormula(formulaList.find((x) => x.FORM_ID == id));
    dispatch(getModificationByFormulaId(id));
  };
  const optionRenderer = ({ label, displayText }, { inputValue }) => {
    const matches = match(label, inputValue);
    const parts = parse(label, matches);

    const appendedText = ` - Sun Ten Patented Formula ${
      isRawType ? " (Only available in granules.) " : ""
    }`;
    const appendedMatches = match(appendedText, inputValue);
    const appendedParts = parse(appendedText, appendedMatches);

    return (
      <div>
        {parts.map((part, index) => (
          <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
            {part.text}
          </span>
        ))}

        {displayText?.includes(" - WPA Patented Formula") && (
          <span>
            {appendedParts.map((part, index) => (
              <span
                key={`appended-${index}`}
                style={{
                  fontWeight: part.highlight ? 700 : 400,
                  color: "green",
                }}
              >
                {part.text}
              </span>
            ))}
          </span>
        )}
      </div>
    );
  };
  const handleChange = (e) => {
    let searchTerm = e.target.value;
    let newList = modificationList.filter(
      (x) =>
        x.DC_Display.toLowerCase().includes(searchTerm.toLowerCase()) ||
        x.MOD_Display.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredList(newList);
  };

  const modifyAction = (cell, row, rowIndex, formatExtraData) => {
    var isSelcted = selectedMod?.MOD_ID == row.MOD_ID;
    return (
      <div className="action-btn-wrapper row">
        <button
          className={`btn-orange btn-table ${isSelcted ? "btn-green" : ""}`}
          onClick={() => {
            setSelectedMod(isSelcted ? null : row);
          }}
        >
          {isSelcted ? "Selected" : "Select"}
        </button>
      </div>
    );
  };

  const columns = [
    {
      dataField: "DC_Display",
      text: "Disease",
      sort: true,
    },
    {
      dataField: "MOD_Display",
      text: "Modification",
      sort: true,
    },
    {
      text: "Action",
      formatter: modifyAction,
      formatExtraData: selectedMod,
    },
  ];

  return (
    <div>
      <p className="page-desc">Find Formulas and Mods based on the Disease.</p>
      {!isRawType && (
        <div className="row align-items-center mb-4 justify-content-between">
          {/* <div className="col-md-5">
            <div className="radio-item">
              <label
                className="container"
                onClick={() => setIncludeDosage(true)}
              >
                Include Suggested Dosages
                <input type="radio" checked={includeDosage} name="existing" />
                <span className="checkmark"></span>
              </label>
            </div>
            <div className="radio-item">
              <label
                className="container"
                onClick={() => setIncludeDosage(false)}
              >
                Do Not Include Suggested Dosages
                <input type="radio" name="new" checked={!includeDosage} />
                <span className="checkmark"></span>
              </label>
            </div>
          </div> */}
          {includeDosage && (
            <>
              <div className="col-md-4 text-right">
                Total amount (grams) of this formula:
              </div>

              <div className=" d-flex justify-content-end">
                <input
                  ref={target}
                  disabled={!includeDosage}
                  type="number"
                  step=".5"
                  min={0}
                  style={{ width: "auto", marginRight: "20px" }}
                  placeholder="enter your dosage"
                  className={`gram-input formula ${
                    dosage == null || isNaN(dosage) ? "red-border" : ""
                  }`}
                  value={dosage}
                  onChange={(e) => {
                    e.target.value >= 0
                      ? setDosage(parseFloat(e.target.value))
                      : setDosage(null);
                  }}
                />
                <Overlay
                  target={target.current}
                  show={dosage == null || isNaN(dosage) || dosage <= 0}
                  placement="top"
                >
                  {(props) => (
                    <Tooltip id="overlay-example" {...props}>
                      You must enter a dosage
                    </Tooltip>
                  )}
                </Overlay>
              </div>
            </>
          )}
        </div>
      )}
      <div className="row">
        <div className="col-md-2">
          <h5 className="cat-title">Formula:</h5>
        </div>
        <div className="col-md-10">
          <Select
            ref={selectRef}
            onChange={(e) => {
              handleItemChange(e.value);
            }}
            placeholder="Please Choose A Formula"
            value={
              selectedFormula
                ? {
                    label: selectedFormula.FORM_Display,
                  }
                : ""
            }
            getOptionLabel={(option) => option.displayText}
            options={formulaList
              .filter((x) => x.FORM_Creator_ID != 2)
              .map((x) => ({
                value: x.FORM_ID,
                displayText: x.FORM_Display,
                isDisabled: isRawType && x.FORM_Creator_ID == 2,
                label:
                  x.FORM_Creator_ID == 2
                    ? x.FORM_Display.split(" - ")[0]
                    : x.FORM_Display,
              }))}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
              option: (props, { isDisabled, isSelected }) => ({
                ...props,
                cursor: isDisabled ? "not-allowed" : "pointer",
                pointerEvents: "auto",
                backgroundColor: isDisabled
                  ? "#ff474c"
                  : isSelected
                  ? "#2684ff"
                  : undefined,
                color: isDisabled ? "white" : isSelected ? "white" : "black",
              }),
            }}
            menuPortalTarget={document.body}
            menuPlacement={"bottom"}
            menuShouldScrollIntoView={false}
            formatOptionLabel={optionRenderer}
          ></Select>
        </div>
      </div>
      {modificationList.length > 0 ? (
        <>
          <div className="row mt-1">
            <div className="col-md-2">
              <h5 className="cat-title">Mod:</h5>
            </div>
            <div className="col-md-10">
              <div className="form-group search">
                <div>
                  <label htmlFor="search">
                    Search: (Disease, Modification)
                  </label>
                  <div className="input">
                    <input
                      name="search"
                      className="form-control"
                      id="search"
                      onChange={handleChange}
                      type="text"
                    ></input>
                  </div>
                </div>
                <FontAwesomeIcon icon={faSearch} size="lg" color="gray" />
              </div>
            </div>
          </div>
          <BootstrapTable
            classes="react-bootstrap-table"
            keyField="ID"
            maxHeight="300px"
            columns={columns}
            data={filteredList}
            headerClasses="header-class"
          />
        </>
      ) : (
        selectedFormula && (
          <p className="page-desc mt-2">
            No Modifications Are Available For This Formula
          </p>
        )
      )}
      <div
        className={`row mt-2 d-flex ${
          isRawType ? "justify-content-end" : "justify-content-between"
        } align-items-center`}
      ></div>
      <div className="d-flex justify-content-end">
        <button
          disabled={
            !selectedFormula ||
            (includeDosage && (dosage <= 0 || isNaN(dosage)) && !isRawType)
          }
          className="col-md-3 btn-orange"
          style={{ marginRight: "20px" }}
          onClick={() => {
            if (formulas.some((x) => x.formulaId === selectedFormula.FORM_ID)) {
              dispatch({
                type: ERROR,
                payload: "Selected Formula is already in the list",
              });
            } else if (selectedFormula.FORM_Creator_ID == 2) {
              dispatch(getAcumaticaHerbById(selectedFormula.FORM_ID));
            } else {
              dispatch(
                getHerbByFormulaId(
                  selectedFormula.FORM_ID,
                  selectedFormula.FORM_Display,
                  () => {
                    if (selectedMod) {
                      dispatch(
                        getHerbById(
                          selectedMod.DC_ID,
                          selectedMod.DSC_ID,
                          selectedFormula.FORM_ID,
                          selectedMod.MOD_ID,
                          selectedMod.MOD_Display,
                          includeDosage
                        )
                      );
                    }
                  },
                  includeDosage ? dosage : 0.001
                )
              );
            }
            closePopup();
          }}
        >
          Add Formula
        </button>
      </div>
    </div>
  );
};
export default SearchByFormulaList;
